import { AxiosError } from 'axios'

import ErrorContent from 'views/ErrorContent'

export function showErrorPage(
  error: AxiosError | null,
  errorMap: Record<number, JSX.Element>
): JSX.Element {
  const errorResponseStatus = error?.response?.status

  errorMap[500] = (
    <ErrorContent title="Internal Server Error" statusCode={500} text="Internal Server Error" />
  )

  if (Object.keys(errorMap).includes(errorResponseStatus!.toString())) {
    return errorMap[errorResponseStatus!]
  }

  return <ErrorContent title="Error" statusCode={500} text="Something went wrong" />
}
